import React, { useContext, useState } from 'react';
import { useMutation, useQuery, useLazyQuery } from '@apollo/client';
import { MainContainer, ContentContainer } from '../../elements';
import { SALE_UPDATE_ASSETS } from './queries';
import { Text, View } from 'react-native';

import DataState from 'app/src/components/DataState';
import { SALES_WITH_COUNT } from 'app/src/components/Sales/queries';
import { Button } from 'app/src/elements/buttons';
import AuthContext from 'app/src/contexts/AuthContext';
import { LOT_NUMBER_YEARS } from 'app/src/components/Sales/Process';
import { Warning, WarningText } from 'app/src/styles';

import { LOT_NUMBER_SUGGESTION } from './queries';

const AddAssetToSale = ({ assetId, setShowModal, saleAsset, refetch }) => {
  const { lotPrefixes } = useContext(AuthContext);
  const [submitting, setSubmitting] = useState(false);

  const [values, setValues] = useState({
    prefix: '',
    year: '',
    suffix: '',
    saleId: '',
    available: [],
    assetId,
  });

  const [updateAssets] = useMutation(SALE_UPDATE_ASSETS, {
    onCompleted: () => {
      setShowModal(false);
      refetch();
    }
  });

  const { loading, error, data } = useQuery(SALES_WITH_COUNT);

  const [loadLotNumberSuggestion] = useLazyQuery(
    LOT_NUMBER_SUGGESTION,
    {
      onCompleted: data => {
        setValues({
          ...values,
          prefix: data.lotNumberSuggestion.lotNumberPrefix,
          year: String(data.lotNumberSuggestion.lotNumberYear).padStart(2, '0'),
          suffix: data.lotNumberSuggestion.lotNumberSuffix,
          available: data.lotNumberSuggestion.availableSuffixes,
        });
      }
    }
  );

  if (loading) {
    return <DataState.Loading />;
  }

  const updateValues = ({ saleId, prefix, year, suffix }) => {
    const newValues = {...values};

    if ('undefined' !== typeof saleId) { newValues.saleId = saleId; }
    if ('undefined' !== typeof prefix) { newValues.prefix = prefix; }
    if ('undefined' !== typeof year) { newValues.year = year; }
    if ('undefined' !== typeof suffix) { newValues.suffix = suffix; }

    if (saleId || prefix || year) {
      if (newValues.prefix) {
        loadLotNumberSuggestion({
          variables: {
            saleId: (newValues.saleId || sales[0].id),
            assetId: newValues.assetId,
            prefix: newValues.prefix,
            year: (newValues.year ? parseInt(newValues.year) : null),
          }
        });
      }
    }

    setValues(newValues);
  };

  const onSubmit = () => {
    if (submitting) { return; }
    setSubmitting(true);

    updateAssets({ variables: {
      saleId: (values.saleId || sales[0].id),
      moveFromOtherSales: !!saleAsset,
      assetInputs: {
        assetId,
        lotNumberPrefix: values.prefix,
        lotNumberYear: (values.year ? parseInt(values.year) : null),
        lotNumberSuffix: (values.suffix ? parseInt(values.suffix) : null),
      }
    }});
  }

  let sales = data?.salesWithCount.entries
    .filter(sale => !(['Processing', 'Closed'].includes(sale.status)))

  if (data && 0 === sales.length) {
    return <Text>No upcoming sales</Text>;
  }

  return (
    <MainContainer>
      <ContentContainer>
        {saleAsset && (
          <Warning>
            <WarningText>
              Asset is currently listed in {saleAsset.sale.name}.
            </WarningText>
            <WarningText>
              Adding it to a new sale will remove it from {saleAsset.sale.name}.
            </WarningText>
          </Warning>
        )}
        <Text>Sales:</Text>
        <select
          type="select"
          value={values.saleId}
          onChange={e => updateValues({ saleId: e.target.value })}
        >
          {sales?.map(sale =>
            <option key={`sale-${sale.id}`} value={sale.id}>
              {sale.name}
            </option>
          )}
        </select>
        <Text>Lot Number:</Text>

        <View style={{flexDirection: 'row'}}>
          <select
            type="select"
            value={values.prefix}
            onChange={e => updateValues({ prefix: e.target.value })}
          >
            <option value=""></option>
            {lotPrefixes?.map(prefix =>
              <option key={prefix.code} value={prefix.code}>
                {prefix.code}
              </option>
            )}
          </select>

          <Text>-</Text>

          <select
            type="select"
            value={values.year}
            onChange={e => updateValues({ year: e.target.value })}
          >
            <option value=""></option>
            {LOT_NUMBER_YEARS?.map(year =>
              <option key={year} value={year}>{year}</option>
            )}
          </select>

          <select
            type="select"
            value={values.suffix}
            onChange={e => updateValues({ suffix: e.target.value })}
          >
            <option value=""></option>
            {values.available.map(suffix =>
              <option key={suffix} value={suffix}>{suffix}</option>
            )}
          </select>
        </View>
        {!submitting && (
          <Button onPress={() => onSubmit()} label={'Add to Sale'} />
        )}
      </ContentContainer>
    </MainContainer>
  )
}

export default AddAssetToSale;
